import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import LegalLinksRow from './LegalLinksRow';
import VocationWorksLogo from './VocationWorksLogo';

const NAVY     = '#0D1B2A';
const AMBER    = '#F5A623';
const WHITE    = '#FFFFFF';
const FONT_HEAD = "'Bebas Neue', sans-serif";
const FONT_BODY = "'DM Sans', sans-serif";

// Shared footer for every public marketing page. Keeps the logo/nav/copyright
// row that already existed on LandingPage, TradesPage, UnionPage, UnionProfile
// and EmployerLanding, plus a real (non-stub) row of legal-page links via
// LegalLinksRow so Privacy/Disclaimer/AUP/Accessibility live in one place.
export default function SiteFooter() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', onResize);
    return () => window.removeEventListener('resize', onResize);
  }, []);

  const NAV_LINKS = [
    { label: t('siteNavbar.forWorkers'),   path: '/trades' },
    { label: t('siteNavbar.forEmployers'), path: '/employers' },
    { label: t('siteNavbar.forUnions'),    path: '/union' },
    { label: t('common.signIn'),           path: '/login' },
  ];

  return (
    <footer style={{ backgroundColor: NAVY, padding: '3rem 2rem 2rem', borderTop: '1px solid rgba(255,255,255,0.06)' }}>
      <div
        style={{
          maxWidth: '1100px', margin: '0 auto',
          display: 'flex', flexDirection: isMobile ? 'column' : 'row',
          alignItems: 'center', textAlign: isMobile ? 'center' : 'left',
          justifyContent: 'space-between', gap: isMobile ? '20px' : '2rem',
          flexWrap: 'wrap',
        }}
      >
        <div
          onClick={() => navigate('/')}
          style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
        >
          <VocationWorksLogo variant="reversed" size={32} />
        </div>

        <div style={{ display: 'flex', gap: '1.5rem', alignItems: 'center', flexWrap: 'wrap', justifyContent: 'center' }}>
          {NAV_LINKS.map(link => (
            <Link
              key={link.path}
              to={link.path}
              style={{ color: 'rgba(255,255,255,0.4)', fontSize: '0.8rem', fontFamily: FONT_BODY, textDecoration: 'none' }}
            >
              {link.label}
            </Link>
          ))}
        </div>

        <div style={{ fontSize: '0.75rem', color: 'rgba(255,255,255,0.28)', fontFamily: FONT_BODY, whiteSpace: 'nowrap' }}>
          {t('common.copyright')}
        </div>
      </div>

      <div
        style={{
          maxWidth: '1100px', margin: '1.5rem auto 0', paddingTop: '1.5rem',
          borderTop: '1px solid rgba(255,255,255,0.06)',
          display: 'flex', justifyContent: 'center',
        }}
      >
        <LegalLinksRow />
      </div>
    </footer>
  );
}
